/**
 * A line of plain words for each entry pack, keyed by its Stripe product id (the
 * candidate server's allow-list, TEST_ENTRY_PACK_PRODUCT_IDS, identical in every
 * Stripe environment).
 *
 * Which packs are on sale, how many entries each holds and what it costs all come
 * from the server (`GET entries/packs`, priced live from Stripe) — never from here.
 * A pack the server sells that has no line here is simply shown without one.
 */

const ENTRY_PACK_DESCRIPTIONS = {
    ts_entry_1: 'Enrol on one test cycle.',
    ts_entry_3: 'Enough for a retake, or for three different tests.',
    ts_entry_5: 'For taking several tests over a few cycles.',
};

export default ENTRY_PACK_DESCRIPTIONS;
